import {
   TextInputForm,
   TextAreaForm,
   Label,
   DatePickerForm,
} from 'src/components/shared/ui/form-field-elements';
import { UseFormReturn } from 'react-hook-form';
import { capitalizeFirstChar } from '@/components/shared/ui/helpers/Helpers';
import { cn } from '@/lib/helper/utils';
import { SalesDocumentFindOneResponse } from 'freelanceman-common';

const ProjectInfoField = ({
   formMethods,
}: {
   formMethods: UseFormReturn<SalesDocumentFindOneResponse>;
}) => {
   const {
      formState: { errors },
   } = formMethods;

   const error = errors.projectTitle;

   return (
      <fieldset
         className={cn(
            'flex flex-1 flex-col grow rounded-xl border border-tertiary p-3 relative gap-3 md:flex-none',
            'sm:w-full',
            error && 'border-general-red'
         )}
      >
         <div className="flex flex-col">
            <div className="flex flex-wrap gap-2 peer order-2 sm:flex-col">
               <div className='flex gap-2 sm:order-2'>
                  <div className="peer flex-1">
                     <Label className="pb-0">Document Number</Label>
                     <TextInputForm fieldName="number" formMethods={formMethods} />
                  </div>
                  <div className="peer flex-1">
                     <Label className="pb-0">Currency</Label>
                     <TextInputForm
                        fieldName="currency"
                        formMethods={formMethods}
                     />
                  </div>
               </div>
               <div className="peer flex-1">
                  <Label className="pb-0">Issue date</Label>
                  <div className="flex gap-1 items-center shrink-0">
                     <DatePickerForm
                        fieldName="issuedAt"
                        formMethods={formMethods}
                        className="items-center text-md font-normal shrink-0"
                     />
                  </div>
               </div>
            </div>
            <h2 className="text-lg text-secondary peer-focus-within:text-primary order-1">
               {capitalizeFirstChar(formMethods.getValues('category'))} Info
            </h2>
         </div>
         <div className="flex flex-col grow">
            <div className="flex flex-col  peer order-2 gap-2 grow">
               <div>
                  <Label className="pb-0">Project Title</Label>
                  <TextInputForm
                     fieldName="projectTitle"
                     required
                     errorMessage="Please enter a project title"
                     formMethods={formMethods}
                  />
               </div>
               <div className='md:hidden'>
                  <Label className="pb-0">Reference Number</Label>
                  <TextInputForm
                     fieldName="referenceNumber"
                     formMethods={formMethods}
                  />
               </div>
               <div className="flex flex-col grow md:hidden">
                  <Label className="pb-0">Project Details</Label>
                  <TextAreaForm
                     fieldName="projectDescription"
                     formMethods={formMethods}
                     className="resize-none grow"
                  />
               </div>
            </div>
         </div>
      </fieldset>
   );
};

export default ProjectInfoField;
